<template>
  <base-card >
          <v-carousel  cycle hide-delimiters show-arrows-on-hover :height="this.carouselHeight">
              <div style="position:absolute;width:100%;height:100%"></div>
            <v-carousel-item
              v-for="(item,i) in sliders"
              :key="i"
              :src="baseURL + item.image"              
            ></v-carousel-item>
          </v-carousel>
      
  </base-card>
</template>

<script>
  export default {
    props: {
      sliders: Array,
    },
    computed:{
      baseURL: {
        get() {return localStorage.getItem('country') == 'TZ' ? 'https://tz.time-zone.store' : 'https://time-zone.store/'}
      }
    },
    methods:{
      getCarouselHeight () {
        // var item = document.getElementsByClassName('v-image__image--cover')
        
        var item = document.getElementsByClassName('v-image__image--cover');

        var ratio = 550/1467;

        this.carouselHeight = item[0].clientWidth * ratio + 'px';
        console.log(item[0].clientWidth + 'px');
        console.log(this.carouselHeight);
        }
    },
    mounted() {
      this.getCarouselHeight()
    },
    data () {
      return {
        carouselHeight: 0,
        items: [
          {
            src: 'https://www.coverwatches.com/assets/TopMoodImages/a4.jpg',
          },
           {
            src: 'https://www.ritani.com/wp-content/uploads/2014/11/diamond-stud-earrings.jpg?3532e0',
          },
          {
            src: 'https://cdn.asiatatler.com/asiatatler/i/hk/2018/11/02192919-skeleton-watches_cover_1584x780.png',
          },
          {
            src: 'https://helenkirchhofer.ch/media/wysiwyg/impudicus/brands/cover/cover-herrenuhren.jpg',
          },
         
        ],
      }
    },
  }
</script>
<style lang="scss" scoped>
.v-window__prev, .v-window__next{

    background: transparent !important
}
 
</style>
 
